module.exports = __webpack_public_path__ + "static/media/odonto_4.1e78b500.jpg";